module.exports = __webpack_public_path__ + "static/media/hamburger-black-outline.59aec7ae.svg";